<template>
  <div v-if="rStations.length > 0">
    <div v-for="(station, i) in rStations" :key="i">
      <v-alert v-if="station.state" :type="station.type" style="overflow-x: auto">
        <slot
          v-if="station.hasOwnProperty('id')"
          v-bind="station"
          :name="station.id">
        </slot>
        <span v-else>{{ station.content }}</span>
      </v-alert>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DynamicAlert',
  data: () => ({ rStations: [] }),
  props: ['value'],
  watch: {
    value(nv) { this.rStations = nv; },
  },
};
</script>
